import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { classeBadgeVariavel, isVariavelParametro } from '@shared/components/formula/utils/formula-badge.util';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

@Component({
    selector: 'app-variaveis-disponiveis-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatFormFieldModule, MatInputModule, EmptyStateComponent],
    templateUrl: './variaveis-disponiveis-section.component.html',
    styleUrl: './variaveis-disponiveis-section.component.css',
})
export class VariaveisDisponiveisSectionComponent {
    @Input() variaveis: VariavelStruct[] = [];
    @Output() variavelSelecionada = new EventEmitter<VariavelStruct>();

    public searchControl = new FormControl('');

    public get variavelFiltradas(): VariavelStruct[] {
        const texto = (this.searchControl.value ?? '').toLowerCase().trim();
        return this.variaveis
            .filter(v => {
                const chave = this.variavelChave(v).toLowerCase();
                const matchTexto = !texto ||
                    chave.includes(texto) ||
                    (v.pathTagXml ?? '').toLowerCase().includes(texto) ||
                    v.descricao.toLowerCase().includes(texto) ||
                    (v.nome ?? '').toLowerCase().includes(texto) ||
                    (v.observacao ?? '').toLowerCase().includes(texto);
                return matchTexto;
            });
    }

    public readonly classeBadgeVariavel = classeBadgeVariavel;
    public readonly isVariavelParametro = isVariavelParametro;

    public inserir(v: VariavelStruct): void {
        this.variavelSelecionada.emit(v);
    }

    public variavelChave(variavel: VariavelStruct): string {
        return variavel.chave || variavel.tagXml || variavel.nome;
    }

    public tooltipVariavel(variavel: VariavelStruct): string {
        return [
            variavel.observacao ?? variavel.descricao,
            `Chave: ${this.variavelChave(variavel)}`,
            variavel.pathTagXml ? `Path XML: ${variavel.pathTagXml}` : null,
        ].filter(Boolean).join('\n');
    }
}
